export default __webpack_public_path__ + "static/media/bot1.97c9ac16.png";